import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Debug only reset localStorage so I don't have to keep doing this over and over again.
// Comment these three lines out or delete them before release.
// localStorage.removeItem("BASE_URL");
// localStorage.removeItem("REGION_SETTING");
// localStorage.removeItem("SUB_DIR_INDEX");
// localStorage.removeItem("KEYWORD_SEARCH");

(async() => {
	const el = document.getElementById('root');
	const BASE_URL = el.getAttribute('BASE_URL');

	const root = ReactDOM.createRoot(el);
	root.render(
		<React.StrictMode>
			{/* options={options} */}
			<App BASE_URL={BASE_URL} />
		</React.StrictMode>
	);
})();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
